export const downloadBoxFile = async (fileId: string, fileName: string, boxAccessToken: string) => {
  try {
    const response = await fetch(
      `https://api.box.com/2.0/files/${fileId}/content`,
      {
        headers: {
          Authorization: `Bearer ${boxAccessToken}`,
        },
      }
    );

    if (!response.ok) throw new Error("Failed to download file");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (err) {
    console.error("Download error:", err);
    return false;
  }
};
